// Script for models page

import * as facets from './includes/facets';
facets.checkFacet();
facets.submitSearchForm();
facets.closeFacet();
facets.clear();
facets.sort();
//     facets.filterModels(); // pas d'import, est appelée par les autres fonctions
facets.updatePageUrl();
facets.addUrlParameter();
facets.pagination();
facets.dropdown();

import * as versus from './includes/versus';
versus.addVersus();
versus.clickRemoveVersus();
versus.removeVersus();
versus.clearVersus();
versus.getThumbnail();

import * as carousel from './includes/carousel';
carousel.sync();
carousel.heightNormalization();


